module.exports = __webpack_public_path__ + "static/media/MarkerGif.fafefca8.gif";